import React, { useRef } from 'react'
import { useLocation } from 'react-router'

import { StyledAnimationProvider as S } from './AnimationProvider.styles'

type TProps = {
  children?: React.ReactNode
}

export const AnimationProvider: React.FC<TProps> = ({ children }) => {
  const { pathname } = useLocation()

  const initialPathnameRef = useRef(pathname)
  const hasNavigatedRef = useRef(false)

  if (pathname !== initialPathnameRef.current) {
    hasNavigatedRef.current = true
  }

  return (
    <S.Wrapper key={pathname} $isAnimated={hasNavigatedRef.current}>
      {children}
    </S.Wrapper>
  )
}
